var _path, _polygon;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBoxArrowOut(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    "aria-labelledby": titleId,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 44",
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "exportTitle"
  }, "Export") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "exportTitle"
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35,14h9.6L34.3,24.4l1.4,1.4L48,13L35.7,0l-1.4,1.5L44.6,12H35c-12.2,0-21,8-21,19h2C16,21,23.8,14,35,14"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "38 42 2 42 2 12 13 12 13 10 0 10 0 44 40 44 40 31 38 31"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoxArrowOut);
export default __webpack_public_path__ + "static/media/box-arrow-out.c3c5a5bfacc1286f2a911f13141ad52b.svg";
export { ForwardRef as ReactComponent };